<template>
  <div class="share-link">
    <van-nav-bar
      v-if="!external"
      class="file-header nav-bar-bgcolor"
      :title="$t('share.detail')"
      @click-left="handleClose"
    >
      <i v-if="showLeft" slot="left" class="iconfont icon-back"/>
    </van-nav-bar>
    <div v-if="isFetching && !loaded" class="share-loading">
      <van-loading color="black" />
    </div>
    <div v-else-if="process.needLogin" class="need-login">
      <svg-icon icon="empty-default1"/>
      <p>{{$t('share.needLogin')}}</p>
      <a :href="loginUrl + '?redirect=' + encodeURIComponent(pathname)" class="btn primary-bgcolor">{{$t('base.loginNow')}}</a>
    </div>
    <div v-else :class="['share-main', external && 'external']">
      <share-header
        v-if="process.share_link && !process.permission_denied && !process.needIdentityCheck && !process.needIdentityAndPasswordCheck && !process.needPassword && !process.passwordError"
        v-show="showShareHeader"
        :external="external"
        :process="process"
        :fileItem="fileItem"
        :isHeaderFold="isHeaderFold"
        @trigger-fold="triggerFold"
      />
      <!-- <div v-if="process.needPassword || process.passwordError" class="password-content">
        <div class="sub-title">{{$t('share.inputPassword')}}</div>
        <van-field
          v-model="password"
          :placeholder="$t('share.password')"
          maxlength="32"
          clearable
        />
        <div v-show="inputError" class="error-message"><i class="iconfont icon-fail"/>{{inputError}}</div>
        <div class="password-action">
          <button :class="['btn', 'primary-bgcolor', !password && 'disabled']" :disabled="!password" @click="sendPassword">{{$t('share.checkoutImmediately')}}</button>
        </div>
      </div> -->
      <div v-if="process.needIdentityCheck || process.needIdentityAndPasswordCheck || process.needPassword || process.passwordError">
        <verify-box
          :process="process"
          :uniqueName="uniqueName"
          :external="external"
          :isMoreShare="isMoreShare"
          @verify-submit="verifySubmit"
        />
      </div>
      <div v-else-if="process.shareLinkError || process.permission_denied" class="share-error">
        <i class="iconfont icon-prompt" />
        <p>{{process.errorMsg}}</p>
      </div>
      <share-content
        v-else-if="process.item"
        :isMoreShare="isMoreShare"
        :external="external"
        :process="process"
        :fileItem="fileItem"
        :hideFileHeader="showShareHeader"
        :uniqueName="uniqueName"
        :fileListData="fileListData"
        @toggle-save="toggleSave"
      />
    </div>
  </div>
</template>
<script>
import {GET_SHARE_LINK, MESSAGES_MARK_READ} from '@/config/api'
import ajax from '@/utils/ajax'
import {i18n} from '@/utils/i18n'
import {approxSize, confirm, pageShare, getPageShareIcon, ua} from '@/utils/common'
import config from '@/config'
import {setThumbIcon} from '@/utils/fileUtils'
import ShareHeader from './ShareHeader'
import ShareContent from './ShareContent'
import VerifyBox from './VerifyBox'

export default {
  name: 'ShareLink',
  components: {
    ShareHeader,
    ShareContent,
    VerifyBox
  },
  i18n,
  props: {
    uniqueName: String,
    external: Boolean,
    isHeaderFold: Boolean
  },
  data () {
    return {
      isFetching: false,
      loaded: false,
      process: {},
      password: '',
      inputError: '',
      pathname: document.location.pathname,
      loginUrl: config.loginUrl,
      showShareHeader: true,
      showLeft: false,
      fileListData: []
    }
  },
  computed: {
    fileItem () {
      const item = this.process.share_link ? this.process.share_link.item : null
      if (item) {
        setThumbIcon(item)
        if (item.thumbnail) {
          item.thumbnail += '&scenario=share'
        }
        if (item.size) {
          item.approxSize = approxSize(item.size)
        }
      }
      return item
    },
    isMoreShare () {
      const item = this.process.share_link ? this.process.share_link.item : {}
      return item && item.type === 'vfolder'
    }
  },
  watch: {
    'store.navStatus' (navStatus) {
      // 新建文件夹并进入
      console.log('store.navStatus', navStatus)
      if (navStatus === 0) {
        this.showLeft = true
      }
    }
  },
  mounted () {
    // eslint-disable-next-line eqeqeq
    this.showShareHeader = !this.$route.query.folder_id || (this.process.share_link && this.process.share_link.item && this.process.share_link.item.id == this.$route.query.folder_id)
    if (!ua.fengyun) {
      this.showLeft = true
    } else if (ua.fengyun && this.store.navStatus === 0) {
      this.showLeft = true
    }
  },
  created () {
    if (config.externalShareResponse) {
      this.formatShareResponse(config.externalShareResponse)
    } else {
      this.fetchShareInfo()
    }
  },
  methods: {
    handleClose () {
      this.$router.go(-1)
    },
    markRead () {
      const messageId = this.$route.params.id
      ajax({
        url: MESSAGES_MARK_READ,
        type: 'POST',
        data: {
          message_ids: [messageId]
        }
      }).then(res => {
        if (res && res.success) {
          this.setState({actionState: {
            action: 'markRead',
            id: messageId
          }})
        }
      })
    },
    fetchShareInfo (data) {
      !this.external && this.markRead()
      this.isFetching = true

      const { password, verification_code, identity } = data || {}

      ajax({
        url: `/apps/share_links/check_multi_share/${this.uniqueName}`,
        data: {
          h5: 1,
          password,
          verification_code,
          identity
        },
        accept_all_errors: true
      }).then(checkData => {
        if (checkData && checkData.item_type === 'vfolder') {
          if (!checkData.success) {
            this.formatShareResponse(checkData, password)
            return
          }

          ajax({
            url: `${config.moreShareUrl}/share/list?scenario=share&unique_name=${this.uniqueName}`,
            noPrefix: true,
            method: 'post',
            contentType: 'application/x-www-form-urlencoded'
          }).then(result => {
            if (result.data) {
              this.formatShareResponse(Object.assign({}, result.data, {
                errors: result.errors,
                share_link: result.data.share_link,
                process: Object.assign({}, result.data.process || {}, {
                  item: result.data.share_link ? result.data.share_link.item : {}
                })
              }), password)
              this.fileListData = result.data.file_list
              this.showShareHeader = true
            }
          })
        } else {
          ajax({
            url: `${GET_SHARE_LINK}/${this.uniqueName}`,
            data: {password, verification_code, identity},
            accept_all_errors: true
          }).then(res => {
            this.formatShareResponse(res, password)
          })
        }
      })
    },
    formatShareResponse (response, password) {
      const {errors} = response
      if (errors) {
        const {permission_denied, external_errors, validation_errors} = errors
        const [{error_code, error_tr_msg}] = external_errors || validation_errors

        switch (error_code) {
          case 'share_link_invalid_password':
            if (password !== undefined) {
              response.passwordErrorMsg = i18n.t('share.passwordError')
              response.passwordError = true
            } else {
              response.needPassword = true
              response.passwordErrorMsg = ''
            }
            break

          case 'share_link_not_found': // 分享内容失效
            response.shareLinkError = true
            break

          case 'action_need_login':
            response.needLogin = true
            break

          case 'need_identity_check':
            response.needIdentityCheck = true
            break

          case 'need_identity_and_password_check':
            response.needIdentityAndPasswordCheck = true
            break

          case permission_denied:
          case 'process_share_link_closed': // 分享已关闭 不显示shareHeader
          default:
            response.permission_denied = true

            break
        }
        response.errorMsg = error_tr_msg
      }

      if (response.needIdentityCheck || response.needIdentityAndPasswordCheck || response.needPassword) {
        response.errorMsg = ''
      }

      if (response.view_type === 3) {
        response.needIdentityCheck = true
        delete response.needPassword
        delete response.passwordError

        delete response.needIdentityAndPasswordCheck
      } else if (response.view_type === 2) {
        response.needIdentityAndPasswordCheck = true
        delete response.needPassword
        delete response.passwordError
        delete response.needIdentityCheck
      } else if (response.view_type === 1) {
        response.needPassword = true
        delete response.needIdentityCheck
        delete response.needIdentityAndPasswordCheck
      }

      if (response.process) {
        if (response.process.type && response.process.type !== 2) {
          response.permission_denied = true
        } else if (response.process.share_link && response.process.share_link.item) {
          const fileItem = response.process.share_link.item
          setThumbIcon(response.process.share_link.item)
          if (fileItem.type === 'file') {
            response.process.share_link.item.approx_size = approxSize(response.process.share_link.item.size)
          } else {
            let query = this.$route.query
            if (!query.folder_id && this.external) {
              this.$router.replace({ query: {...query, folder_id: fileItem.id} })
            }
          }

          if (!response.process.item) {
            response.process.item = response.process.share_link.item
          }
        }
      }
      if (!response.passwordError) {
        this.inputError = ''
      }
      this.loaded = true
      this.isFetching = false
      this.process = {...response, ...response.process}
      if (this.process.share_link && this.process.share_link.item) {
        this.initShareOptions()
      }
    },
    sendPassword () {
      this.fetchShareInfo(this.password)
    },
    toggleSave () {
      if (!(config.user_info && config.user_info.id)) {
        this.toggleQuery('actionsheet')
        confirm({
          className: 'login-fail-dialog',
          message: i18n.t('share.action.needLogin')
        }).then(() => {
          window.location.href = config.loginUrl + '?redirect=' + encodeURIComponent(document.location.pathname)
        })
      } else {
        this.setState({actionState: {
          action: 'sharesave',
          actionItem: this.process.share_link.item
        }})
      }
    },
    triggerFold () {
      this.$emit('trigger-fold')
    },
    initShareOptions () {
      const shareItem = this.process.share_link.item
      pageShare.ready && pageShare.ready((pageShare) => {
        const title = i18n.t('base.pageShareTitle', [config.product_name])
        pageShare.shareAll({
          title,
          link: window.location.href,
          imgUrl: getPageShareIcon(shareItem),
          desc: shareItem.name
        }, {
          accept_share_action: {
            'shareTimeline': (data) => {
              data.title = shareItem.name + ' - '
              if (config.enterprise_info && config.enterprise_info.customized_share_link_page_title) {
                data.title += config.enterprise_info.customized_share_link_page_title
              } else {
                data.title += title
              }
              return data
            }
          }
        })
      })
    },
    verifySubmit (data) {
      this.fetchShareInfo(data)
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.share-link {
  height: 100%;
  background: var(--pageBgColor);

  & .share-loading {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  & .need-login {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;

    & p {
      font-size: 14px;
      color: #b2b7ca;
    }

    & .btn {
      min-width: 110px;
      height: 44px;
      line-height: 44px;
      color: #fff;
      border-radius: 4px;
      margin-top: 24px;
    }
  }

  & .share-main {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  & .share-error {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #c1c1c1;

    & i {
      font-size: 56px;
      color: #b2b7ca;
      margin-bottom: 20px;
    }
  }

  & .password-content {
    & .sub-title {
      color: var(--secondlyTitle);
      font-size: 12px;
      margin: 30px 0 8px 15px;
    }

    & .error-message {
      color: var(--dangerColor);
      margin: 8px 0 0 15px;

      & .iconfont {
        margin-right: 4px;
      }
    }

    & .password-action {
      margin: 20px 15px;
    }

    & .btn {
      color: #fff;
      width: 100%;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      border: 0;
    }
  }
}
</style>
